import React from 'react';

export type NoResultsProps = React.PropsWithChildren;

const NoResults = ({ children }: NoResultsProps) => {
  const message = children || "We couldn't find any results for your search.";

  return (
    <div className="mt-12">
      <h5 className="">{message}</h5>
    </div>
  );
};

export default NoResults;
